export default "__VITE_ASSET__Ba4349ru__"